import {envLoader} from "../../../env/envLoader";
import axios from "axios";
import {loadingDispatcher} from "../../comun/Loading/loadingAction";
import {openAlertAction} from "../../comun/AlertMessage/AlertAction";

const baseUrl = envLoader().base_url;

export const filterAreaCoordinators = async (data) => {
    return await axios.post(`${baseUrl}area_coordinator/filter`, data).then(res => res.data.data);
}

export const getAreaCoordinators  = (values) => {
    return async (dispatch) =>  {
        dispatch(loadingDispatcher({isLoading: true, isError: false, isLoaded: false}));
        return await filterAreaCoordinators(values)
            .then( response => {
                dispatch(loadingDispatcher({isLoading: false, isError: false, isLoaded: true}));
                return response;
            }).catch(reason => {
                dispatch(loadingDispatcher({isLoading: false, isError: true, isLoaded: true}));
                dispatch(openAlertAction({
                    id: 'error-register-lead', severity: 'error',
                    message: "Hubo un error al intentar cargar los usuarios, por favor inténtalo de nuevo", title:'Error'
                }));
                return reason;
            })
    }
}

export const getAreaCoordinatorsExcel = () => {
    axios.post(`${baseUrl}area_coordinator/filterExcel`,null,{ responseType: 'arraybuffer' })
            .then(res => {
                const content  = res.data
                const blob = new Blob([content], { type: 'application/vnd.ms-excel;charset=utf-8' });
                
                const fileName = "informeCoordinadoresDeZona" + "." + "xls";
                if ("download" in document.createElement("a")) {
                    //Non ie Download
                    const elink = document.createElement("a");
                    elink.download = fileName;
                    elink.style.display = "none";
                    elink.href = URL.createObjectURL(blob);
                    document.body.appendChild(elink);
                    elink.click();
                    URL.revokeObjectURL(elink.href);
                    document.body.removeChild(elink);
                } else {
                    navigator.msSaveBlob(blob, fileName);
                }
                
                return res;
            });

};
